import { render, staticRenderFns } from "./IconLightBulbOutline.vue?vue&type=template&id=06905ef0"
import script from "./IconLightBulbOutline.vue?vue&type=script&lang=js"
export * from "./IconLightBulbOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports